import {
	GET_FACILITY_SUCCESS,
	GET_FACILITY_FAILED,
	CREATE_FACILITY_SUCCESS,
	GET_ALL_FACILITY_SUCCESS,
	GET_ALL_FACILITY_FAILED,
	UPDATE_FACILITY_SUCCESS,
	UPDATE_FACILITY_FAILED,
} from '../actions/index';

const initialState = {
	facilities: null,
	loading: true,
	error: null,
	count: null,
	facList: null,
	facListLoading: true,
};

const facilityReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_FACILITY_SUCCESS:
			console.log(action.payload);
			return {
				...state,
				facilities: action.payload.facData,
				error: null,
				loading: false,
				count: action.payload.count,
				facList: null,
			};
		case CREATE_FACILITY_SUCCESS:
			return {
				...state,
				facilities: [...state.facilities, action.payload],
				loading: false,
				error: null,
				count: state.count !== null ? state.count + 1 : 1,
				facList: null,
			};
		case UPDATE_FACILITY_SUCCESS:
			console.log(action.payload)
			return {
				...state,
				facilities: state.facilities.map((facility) =>
					facility.facilityId === action.payload.facilityId
						? action.payload
						: facility
				),
				loading: false,
				error: null,
			};
		case GET_FACILITY_FAILED:
			return {
				...state,
				facilities: null,
				loading: false,
				error: null,
				count: null,
				facList: null,
			};
		case UPDATE_FACILITY_FAILED:
			return {
				...state,
				loading: false,
				error: 'Failed to update facility',
			};
		case GET_ALL_FACILITY_SUCCESS:
			return {
				...state,
				facList: action.payload,
				facListLoading: false,
			};
		case GET_ALL_FACILITY_FAILED:
			return {
				...state,
				facList: null,
				facListLoading: false,
			};
		default:
			return state;
	}
};

export default facilityReducer;
